module.exports = __webpack_public_path__ + "pc/img/ico-project-more.387588aa.svg";